module.exports = __webpack_public_path__ + "img/9.70093dde.jpg";